export const baseClassName = "monday-style-step-indicator-component";
